module.exports = __webpack_public_path__ + "img/space_rocket.19422130.svg";